module.exports = __webpack_public_path__ + "assets/img/thumb-VentureCrowd-Pillar-Page-Resource.f809cb4f.webp";